/**
 * Objectives module
 */
export { buildObjective } from "./definitions";
